<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
    content-class="deposit-withdraw-popup marketingPopup">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-decoration-none" v-bind="attrs" v-on="on">Change Account Type</span>
    </template>
    <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Change Account Type
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        Change Account Type From Here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>MT5 Account</legend>
              <v-select v-model="selectedMT5Account" :items="formattedMT5Accounts" item-text="text" item-value="value"
                solo append-icon="mdi-chevron-down" label="Click to Select" class="custom-select"
                hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Account Type</legend>
              <v-select v-model="selectedAccountType" :items="formattedAccountTypes" item-text="text" item-value="value"
                solo append-icon="mdi-chevron-down" label="Select Your Acc." class="custom-select"
                hide-details></v-select>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="handleConfirm" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">
              Confirm
            </v-btn>
            <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      dialogDeposit: false,
      selectedMT5Account: '',
      selectedAccountType: '',
      userId: '',
    };
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.CLIENTMT5ACCOUNTANDTYPES, REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTMT5ACCOUNTANDTYPES]),
    handleConfirm() {
      this[REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTMT5ACCOUNTANDTYPES]({
        trading_account_type_id: this.selectedAccountType,
        userId: this.userId
      })
      this.dialogDeposit = false;
    },
  },
  computed: {
    ...mapState("reguserdetails", ["accountTypes", "mt5Accounts"]),
    formattedMT5Accounts() {
      return this.mt5Accounts.map(account => ({
        text: `${account.trading_account_no} (${account.tradingaccounttypes.account_type_display})`,
        value: account.trading_account_no
      }));
    },
    formattedAccountTypes() {
      return this.accountTypes.map(type => ({
        text: type.account_type_display,
        value: type.id.toString()
      }));
    },
  },
  async mounted() {
    this.userId = this.$route.params.id
    await this[REGISTERUSERDETAILS__ACTIONS.CLIENTMT5ACCOUNTANDTYPES](this.$route.params.id);
  },
};
</script>